import styled from 'styled-components/native';
import {ITheme, IThemeButton} from '@fkhplus/common/src/styles/themes/interface';
import {IButtonProps, ItextStyle} from "@fkhplus/common/src/components/atoms/Button/interface";
import {Label} from '@fkhplus/common/src/components/atoms/Text';
import {ILabelProps} from "@fkhplus/common/src/components/atoms/Text/Label";
import Icon from '@fkhplus/common/src/components/atoms/icon/icon';

export enum ButtonType {
    primary = 'primary',
    secondary = 'secondary',
    disable = 'disable',
    light = 'light',
    primaryLight = 'primaryLight',
    secondaryLight = 'secondaryLight'
}


const getButtonTheme = (theme: ITheme): IThemeButton => theme.palette.button;


// TODO: Krishna | 25-02-22 | Need to re-align
const getIconColor = (props: { styleProp: IButtonProps, theme: ITheme }): string => {
    if (props.styleProp.iconColor) {
        return props.styleProp.iconColor;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return getButtonTheme(props.theme)[props?.styleProp?.buttonType][props?.styleProp?.disabled ? 'disableIcon' : 'icon'];
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getBackgroundColor = (props: { styleProp: IButtonProps, theme: ITheme }): string => (props?.styleProp?.buttonType != undefined ? getButtonTheme(props.theme)[props?.styleProp?.buttonType][props?.styleProp?.disabled ? 'disableBackground' : 'background'] : 'transparent');

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getTextColor = (props: { styleProp: IButtonProps, theme: ITheme }): string => props?.styleProp?.buttonType ? getButtonTheme(props.theme)[props?.styleProp?.buttonType][props?.styleProp?.disabled ? 'disableText' : 'text'] : getButtonTheme(props.theme)[ButtonType.primary][props?.styleProp?.disabled ? 'disableText' : 'text']


export const StyledIcon = styled(Icon) <{ styleProp: IButtonProps }>`
  color: ${props => getIconColor(props)};
  ${props => ({...props?.styleProp?.iconStyle as object})};
`;

export const Container = styled.TouchableOpacity<{ styleProp: IButtonProps }>`
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Content = styled.View<{ styleProp: IButtonProps, theme: any }>`
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  background-color: ${props => getBackgroundColor(props)};
  padding: 10px;
  border-radius: ${props => props?.styleProp?.borderRadius ? `${props?.styleProp.borderRadius}px` : `20px`};
  ${props => ({...props?.styleProp?.containerStyles as object})};
`;

export const DescriptionText = styled(Label)<ILabelProps>`
  text-align: center;
  margin-top: 4px;
  color: ${props => props.theme.palette.neutral.greys700}
`;

export const ButtonText = styled(Label)<{ styleProp: IButtonProps, textStyle: ItextStyle }>`
  padding-left: 8px;
  color: ${props => getTextColor(props)};
  ${props => {
      const {type, ...restProps  } =  props.textStyle;
      return {...restProps as object}
  }};
`;